import { render, staticRenderFns } from "./AccountRedirection.vue?vue&type=template&id=f428eed8&scoped=true&"
import script from "./AccountRedirection.vue?vue&type=script&lang=js&"
export * from "./AccountRedirection.vue?vue&type=script&lang=js&"
import style0 from "./AccountRedirection.vue?vue&type=style&index=0&id=f428eed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f428eed8",
  null
  
)

export default component.exports